import { Card, CardContent, Grid, Typography, Table, TableHead, TableBody, TableRow, TableCell, Button, LinearProgress, Box } from '@mui/material';
import React, { useRef, useState, useEffect } from 'react';
import { BiCloudUpload } from 'react-icons/bi';
import Papa from 'papaparse';
import { useDispatch } from 'react-redux';
import { BusinessUnitList } from '../../redux/Thunk/AdminModule/AdminThunk';
import { saveClientCsvProfile } from '../../redux/Thunk/ClientModule/ClientThunk';
import { showSnackbar } from '../../redux/Slice/snackbar/snackbarSlice';
import Btn from '../../Components/Ui_elements/Btn';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const ImpClientCsv = () => {
    const fileInputRef = useRef(null);
    const [tableData, setTableData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [csvDataInsrt, setCsvDataInsrt] = useState([]);
    const [csvProgress, setCsvProgress] = useState(false);
    const [percent, setPercent] = useState(0);
    const [vCenterid, setVCenterid] = useState(0);
    const [vCodeRights, setVCodeRights] = useState('');
    const [errorMessage, setErrorMessage] = useState(''); // New state for error messages

    const dispatch = useDispatch();

    const expectedHeaders = [
        'Name', 'E-mail', 'Payment deadline', 'Creation date', 'Street', 'City',
        'ZIP Code', 'Country', 'Memo', 'First order', 'Last order', 'Preselected tax',
        'Sales TAX ID', 'Website'
    ];

    // Fetch country data
    useEffect(() => {
        dispatch(BusinessUnitList())
            .then(response => {
                if (response?.payload?.length > 0) {
                    const retData = response?.payload?.find(item => item.is_default === 1) || response?.payload?.[0];
                    setVCenterid(retData.center_id);
                    setVCodeRights(retData.abbrivation);
                }
            })
            .catch(error => console.error('Error fetching center data:', error));
    }, []);

    const filterByReference = (arr1, arr2) => {
        let resIds = [];
        arr1.filter(el => {
            return arr2.find(element => {
                let element2 = element.trim();
                if (element2 === el.name) {
                    resIds.push(el.id);
                }
            });
        });
        return resIds;
    };

    const filterByReferenceProp = (arr1, arr2) => {
        let resIds = [];
        arr1.filter(el => {
            return arr2.find(element => {
                let element2 = element.trim();
                if (element2 === el.value_name) {
                    resIds.push(el.value_id);
                }
            });
        });
        return resIds;
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) {
            setCsvProgress(false);
            return;
        }

        setCsvProgress(true);
        setPercent(0);

        Papa.parse(file, {
            header: true,
            encoding: "utf-8",
            complete: (results) => {
                const csv = results.data;
                if (csv.length === 0) return;
                setHeaders(Object.keys(csv[0]));
                setTableData(csv);

                let processedData = [];
                let numindex = 0;

                csv.forEach((val, i) => {
                    // Remove the if (i > 0) condition to process all rows
                    val = Object.values(val).map(str => (str != null ? String(str).replace(/�/g, '') : ''));

                    let dtCreationDate = '0000-00-00';
                    if (val[3]) {
                        const dt = val[3].split('.');
                        if (dt.length === 3) {
                            dtCreationDate = `${dt[2]}-${dt[1]}-${dt[0]}`;
                        }
                    }

                    let email = '';
                    let multipleEmail = [];
                    if (val[1]) {
                        const valEmail = val[1].trim().split(/[; ]/)[0];
                        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valEmail);
                        if (isEmail) email = valEmail;

                        const allEmail = val[1].trim().split(/[; ]/);
                        multipleEmail = allEmail.filter(email2 => {
                            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email2);
                        });
                    }

                    const address1 = [
                        { id: "address1_street_number", value: val[4] || '' },
                        { id: "address1_country", value: val[7] || '' },
                        { id: "address1_administrative_area_level_1", value: '' },
                        { id: "address1_locality", value: val[5] || '' },
                        { id: "address1_postal_code", value: val[6] ? val[6].replace(/[^\w\s]/g, '') : '' },
                        { id: "address1_vTimezone", value: "" }
                    ];

                    const countryObj = {
                        countryTitle: "United States: +1",
                        countryFlagClass: "iti-flag us",
                        mobileNumber: ''
                    };

                    const clientTax = {
                        tax_id: val[12] || '',
                        country_code: ""
                    };

                    const obj = {
                        vUserName: val[0] ? val[0].replace(/\*/g, '') : '',
                        vPhone: JSON.stringify(countryObj),
                        vWebsite: val[13] || '',
                        vEmailAddress: email,
                        clientContactvEmail: JSON.stringify(multipleEmail),
                        address1Detail: JSON.stringify(address1),
                        vAddress1: val[4] || '',
                        tmemo: val[8] || '',
                        vStatus: 8,
                        dtCreationDate: dtCreationDate,
                        vCenterid: vCenterid,
                        vCodeRights: vCodeRights,
                        client_currency: 'EUR,€',
                        invoice_no_of_days: val[2] || '',
                        created_id: localStorage.getItem("session_iUserId"),
                        clientTaxInfo: JSON.stringify(clientTax),
                    };


                    processedData.push(obj);
                    numindex++;
                    setPercent(Math.min(Math.round(100 / csv.length * numindex), 97));
                });

                setCsvDataInsrt(processedData);

                setTimeout(() => {
                    setCsvProgress(false);
                    setTimeout(() => {
                        setCsvProgress(true);
                        setPercent(0);
                        fileInputRef.current.value = '';
                    }, 2000);
                }, 1000);
            },
            error: (error) => {
                console.error("Error parsing CSV:", error);
                setCsvProgress(false);
                dispatch(
                    showSnackbar({
                        message: 'Error parsing CSV file. Please check the file and try again.',
                        type: 'error',
                    })
                );
            }
        });
    };

    const saveClientData = () => {
        if (headers.length !== expectedHeaders.length || !expectedHeaders.every((header, index) => header === headers[index])) {
            setErrorMessage(`Invalid CSV format. Expected headers: ${expectedHeaders.join(', ')}`);
            // Dispatch error message using showSnackbar
            dispatch(
                showSnackbar({
                    message: `Invalid CSV format. Expected headers: ${expectedHeaders.join(', ')}`,
                    type: 'error',
                })
            );
            return;
        }

        dispatch(saveClientCsvProfile(csvDataInsrt))
            .then(() => {
                setTableData([]);
                setHeaders([]);
                setCsvDataInsrt([]);
                fileInputRef.current.value = '';
                // Optionally show success message
                dispatch(
                    showSnackbar({
                        message: 'Client data saved successfully!',
                        type: 'success',
                    })
                );
            })
            .catch((error) => {
                dispatch(
                    showSnackbar({
                        message: 'Failed to save client data. Please try again.',
                        type: 'error',
                    })
                );
            });
    };

    return (
        <>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                <Typography variant="h5" mb={2}>Import CSV for Client</Typography>
                <Btn startIcon={<KeyboardBackspaceIcon />} onClick={() => window.history.back()} variant="outlined" >
                    Back
                </Btn>
            </Box>
            <Card>
                <CardContent>
                    <Grid textAlign="start">
                        <Typography mb={1} variant="h6">
                            Import CSV
                        </Typography>
                        <BiCloudUpload
                            size={50}
                            color="#4e2fc4"
                            style={{ cursor: "pointer" }}
                            onClick={() => fileInputRef.current.click()}
                        />
                        <input
                            type="file"
                            accept=".csv"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />
                        {csvProgress && (
                            <LinearProgress
                                variant="determinate"
                                value={percent}
                                sx={{ mt: 2, width: '100%' }}
                            />
                        )}
                    </Grid>
                </CardContent>
            </Card>

            {/* {table Prospect} */}
            <Card sx={{ mt: 3 }}>
                <CardContent>
                    <Typography variant="h6" mb={2}>CSV Data Preview</Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {headers.map((header, index) => (
                                    <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.map((row, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    {headers.map((header, cellIndex) => (
                                        <TableCell key={cellIndex}>
                                            {row[header] || '-'}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {tableData.length > 0 && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={saveClientData}
                            // disabled={btnDisabled}
                            sx={{ mt: 2 }}
                        >
                            Save Client Data
                        </Button>
                    )}
                </CardContent>
            </Card>
        </>
    );
};

export default ImpClientCsv;